import { Center, Stack, Text, Title } from '@buildex/ui';
import { useTranslation } from 'react-i18next';

export function NoModulesPage() {
  const { t } = useTranslation();
  return (
    <Center mih="60vh">
      <Stack align="center" gap="xs">
        <Title order={2}>{t('noModules.title')}</Title>
        <Text c="dimmed">{t('noModules.text')}</Text>
      </Stack>
    </Center>
  );
}
